import { Link, Stack, Typography } from '@mui/material';
import React from 'react';

const Author: React.FC = () => {
    return (
        <Stack
            direction="row"
            justifyContent="center"
            alignItems="center"
            sx={{
                p: 3,
            }}
        >
            <Typography variant="body2">
                &copy;{' '}
                <Link target="_blank" href="https://www.linkedin.com/in/asset-sultanov-se/">
                    Asset Sultanov
                </Link>{' '}
                2022-
                {new Date().getFullYear()}
            </Typography>
        </Stack>
    );
};

export default Author;
